import { authorizationType } from '#authorization/constants'
import { avlPrefix, avlType } from '#avl/constants'
import { AvlJsonSerialization } from '#avl/jsonserializer'
import { AvlDeclarations, AvlPatch } from '#avl/model'
import { detailsType, fishingKindTag, targetSpeciesCategory } from '#details/constants'
import { useDetailsRowParser } from '#details/parser'
import { photographType } from '#photographs/constants'
import { usePhotographsItemParser } from '#photographs/parser'
import { SubmissionParseContext, useGenericPatchParser } from '#record/parser'
import { utils } from 'apprise-core/utils'
import { ParseContext } from 'apprise-frontend-parse/model'
import { useDefaultModelParser, useDefaultParser } from 'apprise-frontend-parse/resource'
import { useDefaultBookParser } from 'apprise-frontend-parse/workbook'
import { useTagStore } from 'apprise-frontend-tags/tag/store'
import { DeepPartial } from 'apprise-core/utils'


export const useAvlParser = () => {


  const modelparser = useDefaultModelParser(useAvlRowParser())

  const bookparser = useDefaultBookParser(modelparser, [detailsType, authorizationType, photographType, avlType])


  // 08/25: retracting support for multi-year submissions, because:
  // 1. we cannot support it in the most useful use case: when new vessels enter the registry with 'prior history'. 
  //    we can only support cases of 'gap history', where a vessel has already an IOTC# but it's been under the rader for a few years. 
  //    it isn't clear how common this is.
  // 2. we can only create one revision with one set of details, the most recent details. 
  //    we lose the details for the other years. 
  // 3. the current flow doesn't support multi-year anyway.

  // const postProcess: ParsePostProcessor<AvlPatch> = (outcome: ResourceParseOutcome<AvlPatch>) => {

  //   const mergePatches = (patches: AvlPatch[]) => patches.reduce((merged, patch) => {

  //     if (!merged[avlType]) return patch

  //     let reduced = merged
  //     let control = patch

  //     if (reduced[avlType].declarations[0].year < control[avlType].declarations[0].year) {
  //       reduced = patch
  //       control = merged
  //     }

      
  //     reduced[avlType].declarations.push(...control[avlType].declarations)
  //     reduced[avlType].declarations.sort((a, b) => (b.year ?? '').localeCompare(a.year ?? ''))

  //     return reduced

  //   }, {} as AvlPatch)


  //   return {

  //     ...outcome,

  //     data: Object.values(utils().index(outcome.data).byGroup(patch => patch.uvi ?? utils().mint('new'))).map(mergePatches)


  //   }

  // }


  return useDefaultParser({ modelparser, bookparser/* , postProcess */ })


}


export const useAvlRowParser = () => {

  const detailsParser = useDetailsRowParser()
  const photoParser = usePhotographsItemParser()

  const tags = useTagStore()

  const speciesTags = tags.allTagsOfCategory(targetSpeciesCategory)

  const getTagIdByCode = (code: string | undefined) => speciesTags.filter(st => st.code).find(st => st.code === code)?.id ?? code

  const parser = (row: AvlJsonSerialization, ctx: ParseContext<SubmissionParseContext>) => {

    const detailsPatch = detailsParser(row, ctx)
    const photoPatch = photoParser(row, ctx)

    const patch: DeepPartial<AvlPatch> = {
      scope: ctx.sheetIdx === 0 ? 'rav' : 'external',
      cmm: '10/08',
      patchedSlots: [avlType],
      [avlType]: {

        timestamp: undefined!,

        id: utils().mint(avlPrefix),

        declarations: [{
          species: getTagIdByCode(row.species),
          year: row.year,
          tenant: detailsPatch[detailsType].flagstate,
          charterer: {
            address: row.chartererAddress,
            name: row.chartererName
          }
        }]

      } satisfies DeepPartial<AvlDeclarations>
    }

    if (patch.scope === 'external') {
      patch.patchedSlots?.unshift(detailsType, photographType)

      patch[detailsType] = detailsPatch[detailsType]
      patch[detailsType].vesselKind = fishingKindTag  // not in the template, must add manually. 
      patch[photographType] = photoPatch[photographType]
    }

    return patch as AvlPatch
  }

  return useGenericPatchParser(parser)

}